export default __webpack_public_path__ + "static/media/logo06.c96325ab.svg";